import { render } from "./OmsModal.vue?vue&type=template&id=02676428"
import script from "./OmsModal.vue?vue&type=script&lang=js"
export * from "./OmsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__